define(["exports", "text!../../assets/respec2.css"], function (_exports, _respec) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _respec = _interopRequireDefault(_respec);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check
  // Module core/style
  // Inserts the CSS that ReSpec uses into the document.
  //
  // IMPORTANT NOTE
  //  To add you own styles, create a plugin that declares the css as a dependency
  //  and create a build of your new ReSpec profile.
  //
  // CONFIGURATION
  //  - noReSpecCSS: if you're using a profile that loads this module but you don't want
  //    the style, set this to true
  const name = "core/style"; // Opportunistically inserts the style, with the chance to reduce some FOUC

  _exports.name = name;
  const styleElement = document.createElement("style");
  styleElement.id = "respec-mainstyle";
  styleElement.textContent = _respec.default;
  document.head.appendChild(styleElement);

  function run(conf) {
    if (conf.noReSpecCSS) {
      styleElement.remove();
    }
  }
});
//# sourceMappingURL=style.js.map